import * as React from 'react'

import { Box, Tag } from '@factorialco/deprecated-design-system'
import { PerformanceValueObjectsReviewProcessStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { tagColor, tagLabel } from 'modules/performance_process/lib/tagConstants'

interface Props {
  status: PerformanceValueObjectsReviewProcessStatusEnum
  archived?: boolean
}

export const StatusTag = ({ status, archived }: Props) => {
  return (
    <Box flexDirection="row" gap="s16">
      <Tag leftItem="circle" inline capitalize type={tagColor(status)}>
        {tagLabel(status)}
      </Tag>
      {archived && (
        <Tag leftItem="circle" inline capitalize type={Tag.Types.grey}>
          {i18n.t('performance_process.reviews.archive_review.filter')}
        </Tag>
      )}
    </Box>
  )
}
